import { Injectable } from "@angular/core";
import { RemoteGatewayFactory } from "../../gateways/remote-gateway-factory";
import { BackendUrl } from "../../models/domains/urls/back-end.url";
import {
  CancellationResolution,
  DeliveryPanelActionResult,
  DeliveryPanelIndicators,
  DeliveryPanelIndicatorsRequest,
  DeliveryPanelOrderDetail,
  DeliveryPanelSearchRequest,
  DeliveryPanelSearchResult,
} from "../../models/domains/pbm/delivery-panel/delivery-panel.model";

@Injectable()
export class DeliveryPanelRepository {
  private readonly headers = { "Content-Type": "application/json" };

  constructor(private remoteGatewayFactory: RemoteGatewayFactory) {}

  public async search(request: DeliveryPanelSearchRequest): Promise<DeliveryPanelSearchResult> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/delivery-panel/orders");
    return (await remoteGateway.postWithHeaders(backendUrl, JSON.stringify(request), this.headers)) as DeliveryPanelSearchResult;
  }

  public async getIndicators(request: DeliveryPanelIndicatorsRequest): Promise<DeliveryPanelIndicators> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/delivery-panel/indicators");
    return (await remoteGateway.postWithHeaders(backendUrl, JSON.stringify(request), this.headers)) as DeliveryPanelIndicators;
  }

  public async getDetail(orderId: number): Promise<DeliveryPanelOrderDetail> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/delivery-panel/orders/" + orderId);
    return (await remoteGateway.getWithHeaders(backendUrl, this.headers)) as DeliveryPanelOrderDetail;
  }

  public async cancel(orderId: number, reason: string): Promise<void> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/delivery-panel/orders/" + orderId + "/cancel");
    await remoteGateway.postWithHeaders(backendUrl, JSON.stringify({ Reason: reason }), this.headers);
  }

  public async resolveCancellation(orderId: number, resolution: CancellationResolution, reason: string): Promise<void> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/delivery-panel/orders/" + orderId + "/cancellation/resolve");
    await remoteGateway.postWithHeaders(backendUrl, JSON.stringify({ Resolution: resolution, Reason: reason }), this.headers);
  }

  public async reprocessPbm(orderId: number, reason: string): Promise<DeliveryPanelActionResult> {
    const remoteGateway = this.remoteGatewayFactory.createDefaultRemoteGateway();
    const backendUrl = new BackendUrl("/api/delivery-panel/orders/" + orderId + "/pbm-reprocess");
    return (await remoteGateway.postWithHeaders(backendUrl, JSON.stringify({ Reason: reason }), this.headers)) as DeliveryPanelActionResult;
  }
}
